import requests from "./httpServices";

export const getMeetingByName = (name, email) => {
  let url = `/element/meeting-by-name?name=${name}`;
  if (email) url += `&email=${encodeURIComponent(email)}`;
  return requests.get(url);
};

export const getMeetingRecordings = (roomId, page = 1, limit = 10) => {
  return requests.get(
    `/element/recordings?roomId=${roomId}&page=${page}&limit=${limit}`
  );
};

export const updateMeetingRecordingName = (data) => {
  return requests.post(`/element/update-recording-name`, data);
};

export const getMeetingRecordingById = (recordingId) => {
  return requests.get(`/element/recordings/${recordingId}`);
};

export const getJoiningToken = (body) => {
  return requests.post(`/element/meeting-token`, body);
};

export const getMeetingSession = (meetingId) => {
  return requests.get(`/element/meeting-session/${meetingId}`);
};

export const saveMeetingSession = (data) => {
  return requests.post(`/rooms/save-meeting-session`, data);
};

export const getUserMeetingSession = () => {
  return requests.get(`/rooms/get-saved-session`);
};

export const getMeetingSessionById = (sessionId) => {
  return requests.get(`/rooms/get-saved-session-by-id/${sessionId}`);
};

export const sendFeedback = (data) => {
  return requests.post(`/rooms/send-meeting-feedback`, data);
};

export const updateCustomMeetingName = (data) => {
  return requests.post(`/rooms/update-custom-meeting-name`, data);
};

export const updateMeetingSessionName = (data) => {
  return requests.post(`/rooms/update-meeting-session-name`, data);
};

export const updateMeetingSessionSettings = (data) => {
  return requests.post(`/rooms/update-meeting-session-settings`, data);
};

export const updateCoHost = (data) => {
  return requests.post(`/rooms/update-cohost`, data);
};

export const updateRoomSetting = (roomId, data) => {
  const formData = new FormData();
  Object.entries(data).forEach(([key, value]) => formData.append(key, value));
  return requests.post(`/rooms/${roomId}`, formData);
};

// Resolve a webinar registration by its email-link token. Returns the
// registrant (firstName/lastName/email) + current webinar state so callers
// (event page, Conference redirect logic) can choose between countdown,
// waiting room / join, or replay presentation without a second round-trip.
// Note: the `requests` helper in httpServices.js already unwraps response.data,
// so we return its result directly — do NOT destructure `.data` again.
export const resolveRegistrationByToken = (meetingId, token) =>
  requests.get(`/auth/registration-by-token/${meetingId}/${token}`);